export const JobSeekersList = [
  {
    title: "Login",
    link: "/candidate/auth",
  },
  {
    title: "Edit Profile",
    link: "/candidate/profile",
  },
  {
    title: "Apply for Job",
    link: "/candidate/jobs",
  },
  {
    title: "Applied Jobs",
    link: "/candidate/applications",
  },
  {
    title: "Conversations",
    link: "/candidate/conversation",
  },
];

export const EmployersList = [
  {
    title: "Login",
    link: "/employer/auth",
  },
  {
    title: "Edit Profile",
    link: "/employer/profile",
  },
  {
    title: "Post a Job",
    link: "/employer/jobs",
  },
  {
    title: "Applications",
    link: "/employer/applicants",
  },
  {
    title: "Employer conversation",
    link: "/employer/conversation",
  },
];
export const quickList = [
  {
    title: "Candidate Profile",
    link: "/candidate/profile",
  },
  {
    title: "Apply for Job",
    link: "/candidate/jobs",
  },
  {
    title: "Applied Jobs",
    link: "/candidate/applications",
  },
  {
    title: "Candidate Chat",
    link: "/candidate/conversation",
  },
  {
    title: "Login",
    link: "/employer/auth",
  },
  {
    title: "Employer Profile",
    link: "/employer/profile",
  },
  {
    title: "Post a Job",
    link: "/employer/jobs",
  },
  {
    title: "Applications",
    link: "/employer/applicants",
  },
  {
    title: "Employer Chat",
    link: "/employer/conversation",
  },
];
export const pages = [
  {
    id: 0,
    label: "Home",
    path: "/",
    bgc: "#f99d1c",
    c: "#fff",
  },

  {
    id: 1,
    label: "Find Jobs",
    path: "/candidate/auth",
    bgc: "#f99d1c",
    c: "#fff",
  },
  {
    id: 2,
    label: "Find Candidates",
    path: "/employer/auth",
    bgc: "#5ba3d9",
    c: "#fff",
  },
];

export const section2_info = [
  {
    img: "https://png.pngtree.com/template/20191014/ourmid/pngtree-colorful-diagram-business-and-accounting-logo-image_318295.jpg",
    text: "Accounting",
  },
  {
    img: "https://www.waytojob.in/assets/img/o22.png",
    text: "Construction",
  },
  {
    img: "https://www.waytojob.in/assets/img/o33.png",
    text: "Technology",
  },
  {
    img: "https://www.waytojob.in/assets/img/o44.png",
    text: "Sales",
  },
  {
    img: "https://www.waytojob.in/assets/img/o5.png",
    text: "Medical",
  },
  {
    img: "https://www.waytojob.in/assets/img/o6.png",
    text: "Engineering",
  },
];
export const section3_info = [
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/microsoft.png",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
  {
    company: "Adobe",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/adobe-1.png",
    jobType: "Freelance",
    title: "Backend Engineer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "3000",
  },
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/Twilio-1.png",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/genesys-1.jpg",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/Nutanix.png",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/mathworks.png",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/Qualtrics.jpg",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
  {
    company: "Microsoft",
    img: "https://www.thesoftwarereport.com/wp-content/uploads/2022/07/Cvent.png",
    jobType: "Freelance",
    title: "Senior UI Designer",
    workType: "Fulltime",
    desc: " gewegteg",
    salary: "2500",
  },
];
export const skillSet = [
  "Java",
  "JavaScript",
  "React",
  "HTML",
  "Angular",
  "CSS",
  "Bootstrap",
];
export const domainItems = [
  "Frontend",
  "Backend",
  "Full Stack",
  "React",
  "JavsScript",
  "Java",
  "C++",
];
